import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_URL } from '../config';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const sessionExpired = new URLSearchParams(location.search).get('reason') === 'session-expired';

  useEffect(() => {
    // Проверяем, авторизован ли пользователь
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (token && user.role) {
      // Перенаправляем в зависимости от роли
      redirectByRole(user.role);
    }
  }, [navigate]);

  const redirectByRole = (role) => {
    switch (role) {
      case 'admin':
        navigate('/users', { replace: true });
        break;
      case 'adminb24':
        navigate('/users', { replace: true });
        break;
      case 'cutter':
        navigate('/cutting', { replace: true });
        break;
      case 'cutterb24':
        navigate('/cuttingb24', { replace: true });
        break;
      case 'driller':
        navigate('/drilling', { replace: true });
        break;
      case 'drillerb24':
        navigate('/drillingb24', { replace: true });
        break;
      case 'zakalka':
        navigate('/zakalka', { replace: true });
        break;
      case 'zakalkab24':
        navigate('/zakalkab24', { replace: true });
        break;
      case 'matovka':
        navigate('/matovka', { replace: true });
        break;
      case 'matovkab24':
        navigate('/matovkab24', { replace: true });
        break;
      case 'sclad':
        navigate('/sclad', { replace: true });
        break;
      case 'scladb24':
        navigate('/scladb24', { replace: true });
        break;
      case 'loft':
        navigate('/loft', { replace: true });
        break;
      case 'loftb24':
        navigate('/loftb24', { replace: true });
        break;
      case 'upak':
        navigate('/upak', { replace: true });
        break;
      case 'upakb24':
        navigate('/upakb24', { replace: true });
        break;
      case 'designer':
      case 'franchise':
        navigate('/visualloft', { replace: true });
        break;
      default:
        navigate('/cutting', { replace: true });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error: ${response.status}`);
      }
      
      const data = await response.json();
      // Сохраняем данные в localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      
      await login(data.user, data.token);

      // Перенаправляем пользователя в зависимости от роли
      redirectByRole(data.user.role);
      
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Произошла ошибка при входе');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Luther
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {sessionExpired && !error && (
            <div className="rounded-md border border-amber-200 bg-amber-50 p-4">
              <div className="text-sm text-amber-800">
                Сеанс устарел. Войдите ещё раз своим обычным логином и паролем.
              </div>
            </div>
          )}
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Имя, телефон или email"
                disabled={loading}
              />
            </div>
            <div>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Құпиясөз"
                disabled={loading}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="text-sm text-red-700">{error}</div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Кіру...' : 'Кіру'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
